<script lang="ts" setup>
import { TOP_MAGAZINE_SLUGS, customPaths } from "~/utils/constants"

const route = useRoute()
const { locale } = useI18n()
const { trackArticleView } = useMagazineArticleTracker()
const isLoading = ref(true)

const { data, error, pending } = await usePage(
  `/api/gluon/fetchArticlePage/${locale.value}/${
    route.params.slug as string
  }/article.js`
)

// As per TF-2146, when an article DOESN'T have a connected category that exists OR ITS NOT "tutti-i-post" (or the legacy "posts"), then return an "404" error paged
const categoryExists =
  (data?.value?.categories?.some(
    (category) => category.slug === route.params.category
  ) ??
    false) ||
  route.params.category === TOP_MAGAZINE_SLUGS.allPosts ||
  route.params.category === TOP_MAGAZINE_SLUGS.legacyAllPosts

if (!categoryExists || error.value) throw createError({ statusCode: 404 })

// As per TF-2737, when using "tutti-i-post" (or the legacy "posts") category slug, redirect to the canonical page URL
const mainCategorySlug = data?.value?.categories?.[0]?.slug
if (mainCategorySlug && route.params.category !== mainCategorySlug) {
  if (!!mainCategorySlug) {
    navigateTo(
      `${customPaths.magazineRoot}/${mainCategorySlug}/${route.params.slug}`,
      {
        redirectCode: 301
      }
    )
  }
}

onMounted(() => {
  useTimeoutFn(() => {
    isLoading.value = false

    // Track article view when page is loaded and data is available
    if (data.value?.title) {
      trackArticleView(data.value.title, route.fullPath)
    }
  }, 500)
})
</script>

<template>
  <div class="article-page">
    <SkeletonSingleArticle
      v-if="isLoading || pending"
      class="hidden-no-script"
    />
    <PagesArticle
      v-if="data"
      v-bind="data"
      :class="{ hidden: isLoading }"
      class="show-no-script"
    />
  </div>
</template>
